class APIS {
	apis() {
		return {
			fetchAll: {
				headers: {
					"xt-user-token": null,
				},
				method: "get",
				path: "/fetch/tutorial-videos/all",
			},
		};
	}
}
export default new APIS();
